<template>
    <div>
        <div style="margin-bottom: 20px;">
            视频生成
            <div style="font-size: 12px;color: #999;">
                无需找视频，利用大量视频数据进行混合运算合成新的视频，通过率可达99%
            </div>
        </div>
        <Balance ref="Balance"></Balance>
        <div style="margin-top: 20px;display: flex;flex-wrap: wrap;">
            <div style="width: 160px;padding: 0;background-color: #fff;margin: 10px 15px;box-shadow: rgb(115 149 255 / 24%) 0px 4px 21px 0px;"
                v-for="(item, i) in list" :key="i">
                <div style="position: relative;">
                    <!-- <video :src="item.video" style="height: 280px;width: 100%;"
                        controls="controls" controlslist="nodownload"></video> -->
                    <el-image :src="item.image" style="height: 200px;width: 100%;" fit="cover">

                    </el-image>
                    <div style="position:absolute;z-index: 99;top:0;right: 0;left: 0;bottom: 0;display: flex;align-items: center;justify-content: center;background-color: rgb(99,99,99,0.2);"
                        @click="lookvideo_fc(item)">

                        <i class="el-icon-video-play" slot="suffix" style="font-size: 45px;color: #fff;"></i>
                    </div>
                </div>
                <div style="padding: 10px 10px 15px 10px;">
                    <div style="text-align: center;font-size: 14px;color: #666;">{{ item.name }}</div>

                    <div style="margin-top: 5px;display: flex;justify-content: center;"
                        v-if="item.text == 0 && item.url_type == 0">
                        <el-tag size="mini" type="info">直接生成</el-tag>
                    </div>
                    <div style="margin-top: 5px;display: flex;justify-content: center;" v-else>
                        <el-tag size="mini" type="danger" v-if="item.text == 1" style="margin: 0px 2px;"><i class="el-icon-edit"
                            style="margin-right: 5px;"></i>需文字</el-tag>
                        <el-tag size="mini" type="success" v-if="item.url_type == 1" style="margin: 0px 2px;"><i class="el-icon-link"
                            style="margin-right: 5px;"></i>需链接</el-tag>
                    </div>
                    <el-button style="width: 100%;margin-top: 10px;" size="small" icon="el-icon-scissors" type="primary"
                        @click="ks(item)">生成同款/2点</el-button>

                </div>
            </div>

        </div>
        <div class="el-image-viewer__wrapper" style="z-index: 2000;" v-if="lookvideo.length != 0">
            <div class="el-image-viewer__mask" @click="lookvideo_close"></div>

            <span class="el-image-viewer__btn el-image-viewer__close">
                <i class="el-icon-close" @click="lookvideo_close"></i>
            </span>
            <div class="el-image-viewer__canvas" style="display: flex;flex-direction: column;">
                <div ondragstart="return false;" class="el-image-viewer__img"
                    style="transform: scale(1) rotate(0deg); margin-left: 0px; margin-top: 0px; height: 650px; max-height: 80%; max-width: 80%;">
                    <video :src="lookvideo.video" style="max-height: 100%;max-width: 100%;width: auto;height: auto;"
                        controls="controls" controlslist="nodownload"></video>
                    <div style="color: #fff;text-align: center;">
                        <div> {{ lookvideo.name }} </div>
                        <el-button style="margin-top: 10px;font-size: 14px;" size="medium" icon="el-icon-scissors"
                            type="primary" @click="ks(lookvideo)">制作同款/2点</el-button>
                    </div>

                </div>

            </div>


        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Balance from './Balance.vue';
export default {
    name: '',
    components: {
        Balance
    },
    // 定义属性
    data() {
        return {
            list: [],
            lookvideo: []
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        get_list() {
            this.$ajax.get('qhy/user/video_create').then(res => {
                // console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.list = jg.data
                }

            })
        },
        lookvideo_fc(item) {
            // console.log(item)
            this.lookvideo = item
        },
        lookvideo_close() {
            this.lookvideo = []
        },
        ks(item) {

            if (item.text == 1) {
                this.$prompt('请输入文字生成视频', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'msbox',
                    inputValidator: (value) => {
                        if (value.length > 1200) {
                            return '字数不能大于1200';
                        }
                    },

                }).then(({ value }) => {
                    
                    this.tj_ks(value, item)
                }).catch(() => {

                })
            } else if (item.url_type == 1) {
                this.$prompt('请输入视频链接提取音频', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'msbox',
                    inputPattern: /http[s]?:\/\/(?:[a-zA-Z]|[0-9]|[$-_@.&+]|[!*\(\),]|(?:%[0-9a-fA-F][0-9a-fA-F]))+/,
                    inputErrorMessage: '输入链接不正确'

                }).then(({ value }) => {
                    if (value.length > 500) {
                        this.$msg.error('链接过长')
                    }
                    this.tj_ks(value, item)
                }).catch(() => {

                })
            }
            else {
                this.$confirm('确定要制作 ' + item.name + ' 同款吗?', '制作提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success',
                    customClass: 'msbox',
                }).then(() => {
                    this.tj_ks('tpmn', item)
                })

            }
            // console.log(item)
        },
        tj_ks(url, item) {
            const loading = this.$loading(this.$loadinginfo);
            var data = item
            data['url'] = url
            data['type'] = 4
            // var data = {
            //     'url': url,
            //     'ms': item.ms,
            //     'type': 4,
            // }
            this.$ajax.post('/qhy/user/makevieo', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                // console.log(res.data)
                if (res.data.status == 200) {
                    // console.log(index)
                    this.$msg.success(res.data.msg)
                    this.$refs.Balance.get_user()
                } else {
                    this.$msg.error(res.data.msg)
                }
                loading.close();
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.get_list()
        this.common.ismobile(this)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/User/Video_create.vue


// WEBPACK FOOTER //
// src/components/User/Video_create.vue